/**
 * Defines Kendo UI's culture overrides
 * https://docs.telerik.com/kendo-ui/framework/globalization/definecultureinfo
 */

export default {
  numberFormat: {
    currency: {
      pattern: ["-$n", "$n"],
    },
  },
};
